export default __webpack_public_path__ + "static/emilka-4fabcc889c5dba1c71ebbcd9e2724e00.png";